import { render, staticRenderFns } from "./Learned.vue?vue&type=template&id=5cbf5f03&scoped=true&v=4"
import script from "./Learned.vue?vue&type=script&lang=js&v=4"
export * from "./Learned.vue?vue&type=script&lang=js&v=4"
import style0 from "./Learned.vue?vue&type=style&index=0&id=5cbf5f03&scoped=true&lang=css&v=4"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbf5f03",
  null
  
)

export default component.exports